export const ACTIVE_AT_LOCATION_NAME = 'activeAtLocation';
export const DISPLAY_ON_LOCATION_PAGE_NAME = 'displayOnLocationPage';
